$(function() {
	$('.js-select-lang').on('click', function(){
        $('#switch_language').val($(this).attr('value'));
        $('#language_selector').submit();
    });
});
